<template>
	<div>
		<div class="filter-inline-panel cle">
			<div class="list-opinion fr">
				<el-button type="primary" size="mini" @click="add('')" v-if="hasBtn('add')">{{$t('index.add')}}</el-button>
			</div>
		</div>
		<el-table :data="list" size="mini" border>
			<el-table-column :prop="lang=='cn'?'name_cn':'name'" align="center" :label="$t('course_index.teacher')" data-name="老师" width="150"></el-table-column>
			<el-table-column :prop="lang=='cn'?'theme_cn':'theme'" align="center" :label="$t('course_index.theme')" data-name="主题"></el-table-column>
			<el-table-column prop="price" align="center" :label="$t('course_index.price')" data-name="学费">
				<template slot-scope="{row}">${{row.price}}</template>
			</el-table-column>
			<el-table-column prop="cate_id" align="center" :label="$t('course_index.cate')" :formatter="cate_id_f" data-name="分类"></el-table-column>
			<el-table-column prop="center_id" align="center" :label="$t('course_index.center')" data-name="学习中心">
				<template slot-scope="{row}">{{row.center_id | center_f(this_)}}</template>
			</el-table-column>
			<el-table-column :label="$t('index.operation')" align="center" fixed="right" width="350">
				<template slot-scope="{row}">
					<el-button size="mini" type="primary" v-if="hasBtn('add')" @click="add(row)" data-name="编辑">{{$t('index.edit')}}</el-button>
					<el-button size="mini" type="danger" v-if="hasBtn('status')&&row.is_up==1" data-name="上线" @click="up(row,0)">{{$t('course_index.up_0')}}</el-button>
					<el-button size="mini" type="success" v-if="hasBtn('status')&&row.is_up==0" data-name="下线" @click="up(row,1)">{{$t('course_index.up_1')}}</el-button>
					<el-button size="mini" type="primary" v-if="hasBtn('virtual')" @click="router_url('/private_index',{id:row.id})" data-name="虚拟班级">{{$t('course_index.virtual')}}</el-button>
					<el-button size="mini" type="danger" v-if="hasBtn('del')" @click="del(row)" data-name="删除">{{$t('index.del')}}</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="page-pagination">
			<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pagerCount="5"></el-pagination>
		</div>
		<el-dialog :title="$t('index.dialog_title')" :close-on-click-modal="false" :visible.sync="editFormVisible" width="1200px">
			<el-form label-width="80px" ref="editForm" size="mini" label-position="top" :rules="editFormRules" :model="editForm">
				<el-row class="tree-content" :gutter="20">
					<el-col :span="8">
						<el-form-item :label="$t('index.cn')+$t('course_index.theme')" prop="theme_cn" data-name="主题">
							<el-input v-model="editForm.theme_cn" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="$t('index.en')+$t('course_index.theme')" prop="theme" data-name="主题">
							<el-input v-model="editForm.theme" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="$t('course_index.cate')" prop="cate" data-name="分类">
							<el-cascader v-model="editForm.cate" class="w100" :props="props" :options="cateOption"></el-cascader>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.teacher')" prop="teacher_id" data-name="老师">
							<el-select v-model="editForm.teacher_id" class="w100" :placeholder="$t('index.select')">
								<el-option v-for="(item,index) in teacher" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="String(item.teacher_id)"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('parent_index.seller')" prop="course_seller_id" data-name="销售">
							<el-select v-model="editForm.course_seller_id" class="w100" :placeholder="$t('index.select')">
								<el-option v-for="(item,index) in courseSellerList" :key="index" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.is_show_front')" prop="is_show_front" data-name="是否显示再首页">
							<el-switch v-model="editForm.is_show_front" active-color="#ff4949" :active-value="0" :inactive-value="1" inactive-color="#13ce66" :active-text="$t('course_index.hide')" :inactive-text="$t('course_index.show')"></el-switch>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.power_type')" prop="power_type" data-name="状态">
							<el-select v-model="editForm.power_type" class="w100" :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?item.name_cn:item.name" :value="item.code" :key="index" v-for="(item,index) in STATUS"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.administrators')" prop="seller_id" data-name="管理员">
							<el-select v-model="editForm.seller_id" multiple class="w100" :placeholder="$t('index.select')">
								<el-option v-for="(item,index) in sellerList" :key="index" :label="item.name" :value="String(item.id)"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4" v-if="editForm.power_type=='protected'">
						<el-form-item :label="$t('course_index.password')" prop="password" data-name="密码">
							<el-input v-model="editForm.password " :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.price_type')" prop="price_type" data-name="价格类型">
							<el-switch v-model="editForm.price_type" active-color="#ff4949" active-value="￥" inactive-value="$" inactive-color="#13ce66" :active-text="$t('course_index.price_type1')" :inactive-text="$t('course_index.price_type2')"></el-switch>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-button type="primary" size="mini" @click="add_time('')">{{$t('course_index.add_time')}}</el-button>
					<p><br></p>
				</el-row>
				<el-row :gutter="10" v-for="(item,index) in editForm.time_length_arr" :key="index">
					<el-col :span="4">
						<el-form-item :label="$t('coupon_index.time_length')" prop="time_length" data-name="时长">
							<el-input v-model="item.time_length" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.price')+'('+editForm.price_type+')'" prop="price" data-name="价格">
							<el-input v-model="item.price" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('course_index.center')" prop="center_id" data-name="学习中心">
							<el-select v-model="item.center_id" class="w100" :placeholder="$t('index.select')">
								<el-option v-for="(items,indexs) in learnCenter" :key="indexs" :label="lang=='cn'?items.name_cn:items.name" :value="items.id" v-if="items.course_type==0||items.course_type==3"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="$t('course_index.zoom')" prop="zoom" data-name="zoom链接">
							<el-input v-model="item.zoom" :placeholder="$t('index.pleaseInput')" type="textarea" :autosize="{ minRows: 2, maxRows: 2}"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="2">
						<i class="fint el-icon-remove" @click="del_time(item,index)"></i>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item :label="$t('index.cn')+$t('course_index.introduce')" prop="content_cn" data-name="说明">
							<editor-bar v-model="editForm.content_cn"></editor-bar>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('index.en')+$t('course_index.introduce')" prop="content" data-name="说明">
							<editor-bar v-model="editForm.content"></editor-bar>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="privateCourseAction('editForm')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
// import EditorBar from '@/components/wangEnduit.vue'
export default {
	computed: {
		props(){
			return{
				value: 'id',
				label: this.lang=='cn'?'name_cn':'name',
			}
		},
		editFormRules(){
			return{
			}
		},
	},
	components: {
		// EditorBar,
	},
	data() {
		return {
			this_:this,
			editFormVisible: false,
			pages: {
				page: 1,
				count: 0,
				perpage: 20,
			},
			list:[],
			editForm: {},
			cateOption: [],
			teacher:[],
			sellerList:[],
			courseSellerList:[],
			STATUS:[],
			learnCenter:[],
			// state:1未确认2购买3已确定
		}
	},
	// 初始事件
	mounted: function () {
		this.config();
		this.init();
	},
	// 事件
	methods: {
		config() {
			this.$post('cateOption', {type:'3'}).then((res) => {
				this.cateOption=this.xunhaun(res.show);
			})
			this.$post('courseScreen', {}).then((res) => {
				this.learnCenter=res.learnCenter;
				this.teacher=res.teacher;
				this.sellerList=res.sellerList;
				this.courseSellerList=res.courseSellerList;
			})
			this.$post('getDictionaryValue',{code:'STATUS'}).then((res) => {
				this.STATUS = res.STATUS;
			})
		},
		// 获取课程类表
		init(){
			var this_ = this;
			var date_time=this_.date_time(5);
			var datas={
				date_time:date_time.join(','),
				page: this_.pages.page,
				num: this_.pages.perpage,
			}
			var url = "privateCourseList";
			this_.$post(url,datas).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.sum;
			})
		},
		// 新建编辑
		add(data,copy) {
			var this_ = this;
			if (data) {
				var data_data=JSON.parse(JSON.stringify(data));
				var editForm = data_data;
				var cate = [];
				if (data_data.cate_id) {
					cate[0]=data_data.cate_id;
					if (data_data.cate_node_id) {
						cate[1]=data_data.cate_node_id;
						if (data_data.cate_three_id) {
							cate[2]=data_data.cate_three_id;
							if (data_data.cate_four_id) {
								cate[3]=data_data.cate_four_id;
							}
						}
					}
				}
				editForm['cate'] = cate;
				var seller_id=[];
				if (data_data.seller_id) {
					seller_id=String(data_data.seller_id).split(',');
				}
				editForm['seller_id'] = seller_id;
				this_.editForm = editForm;
				this_.editFormVisible = true;
			} else {
				this_.editForm = {
					cate_id: '',
					cate_node_id: '',
					cate_three_id: '',
					cate_four_id: '',
					theme: '',
					theme_cn: '',
					content: '',
					content_cn: '',
					id:'',
					seller_id:[],
					course_seller_id:'',
					teacher_id: '',
					is_show_front:0,
					cate:[],
					power_type:'',
					password:'',
					price_type:'$',
					time_length_arr:[],
				}
				if (this_.$refs.editForm) {
					this_.$refs.editForm.resetFields();
				}
				this_.editFormVisible = true;
			}
		},
		add_time(){
			var this_=this;
			var obj={
				time_length: '',
				price: '',
				center_id:'',
				zoom:'',
			}
			this_.editForm.time_length_arr.push(obj);
		},
		del_time(data,index){
			var this_ = this;
			if (data.id) {
				var url = "privateCourseAction";
				var datas={
					id:data.id,
				}
				this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
					this_.$post(url, datas).then((res) => {
						this_.removeByIndex(this_.editForm.time_length_arr,index);
					})
				})
			}else{
				this_.removeByIndex(this_.editForm.time_length_arr,index);
			}
		},
		// 帖子保存
		privateCourseAction(){
			var this_ = this;
			var url = "privateCourseAction";
			var time_length_arr=JSON.stringify(this_.editForm.time_length_arr);
			var datas=JSON.parse(JSON.stringify(this_.editForm));
			datas['time_length_arr']=time_length_arr;
			if (this_.editForm.cate.length>0) {
				datas['cate_id']=this_.editForm.cate[0];
				datas['cate_node_id']=this_.editForm.cate[1]||'';
				datas['cate_three_id']=this_.editForm.cate[2]||'';
				datas['cate_four_id']=this_.editForm.cate[3]||'';
			}
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					this_.$post(url, datas).then((res) => {
						this_.$message.success(this_.$t('index.operation_success'));
						this_.init();
						this_.editFormVisible = false;
					})
				}
			})
		},
		// 删除
		del(data) {
			var this_ = this;
			var url = "privateCourseDelete";
			var datas = {
				id: data.id
			};
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},
		// 上下线
		up(data,value){
			var this_ = this;
			var url = "changeField";
			var datas = {
				pk_id: data.id,
				table:'private_course',
				field:'is_up',
				value:value,
			};
			this_.$post(url, datas).then((res) => {
				this_.$message.success(this_.$t('index.operation_success'));
				this_.init();
			})
		},
		// 从明天开始获取s天时间戳
		date_time(s){
			var dateobj = new Date();
			let year = dateobj.getFullYear();
			let month = dateobj.getMonth();
			let date = dateobj.getDate();
			let hour = dateobj.getHours();
			let minute = dateobj.getMinutes();
			let second = dateobj.getSeconds();
			var datetime_array=[];
			for (var i = 0; i < s; i++) {
				datetime_array[i]= Math.round(new Date(year,month,(date+i+1),0,0,0).getTime()/1000);
			}
			return datetime_array;
		},
		// 分类显示文字
		cate_id_f(w, s, d){
			var this_=this;
			var id = w.cate_id;
			var id_id = w.cate_node_id;
			var id_id_id = w.cate_three_id;
			var id_id_id_id = w.cate_four_id;
			var cate='';
			var lang_is=this_.lang=='cn'
			var cateOption=this_.cateOption;
			this_.cateOption.forEach(function(e,i) {
				if (e.id== w.cate_id) {
					cate=lang_is?e.name_cn:e.name;
					e.children&&e.children.forEach(function(ee,ii) {
						if (ee.id==id_id) {
							cate+='/'+(lang_is?ee.name_cn:ee.name);
							ee.children&&ee.children.forEach(function(eee, iii) {
								if (eee.id==id_id_id) {
									cate+='/'+(lang_is?eee.name_cn:eee.name);
									eee.children&&eee.children.forEach(function(eeee, iiii) {
										if (eeee.id==id_id_id_id) {
											cate+='/'+(lang_is?eeee.name_cn:eeee.name);
										}
									});
								}
							});
						}
					});
				}
			});
			return cate
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		},
	},
	// 过滤器
	filters: {
		center_f(v,this_){
			var list=this_.learnCenter;
			var fanhuizhi="";
			list.forEach(function(e, i) {
				if (e.id==v) {
					fanhuizhi=this_.lang=="cn"?e.name_cn:e.name;
				}
			});
			return fanhuizhi
		},
	}
}
</script>
<style scoped>
.fint {
	font-size: 28px;
	margin-top: 38px;
	cursor: pointer;
}
.red{
	color: #fff;
	background-color: red;
}
.green{
	color: #fff;
	background-color: green;
}
</style>
<style type="text/css">
.el-date-editor--timerange.el-input__inner.w100 {
    width: 100%;
}
textarea{
	font-family: inherit;
}
</style>



// WEBPACK FOOTER //
// src/views/teacher/course_private.vue